import { useContext } from 'react';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import DDRComplete from '.';
import { useUser } from '../../state/user';
import { useApp, useAppDispatchers } from '../../state/app';
import { useToggles } from '../../state/toggles';

const DDRCompleteContainer = () => {
  const { analytics } = useContext(AnalyticsContext);
  const { registeredUser, promotionId, nextRegStep, currentPlan, partner } =
    useUser();
  const {
    answers,
    flowId,
    appOs,
    error,
    upgradePlanError,
    message,
    upgradePlanErrorMessage,
    needsVerification,
    registrationToken,
    completeUser
  } = useApp();
  const { getFundingAccounts, postRegComplete, queryGetUser, subscribeSMS } =
    useAppDispatchers();
  const {
    creditWaitlistEnabled,
    planFlow,
    improvedDownloadScreen,
    enableCorePriceChange,
    enableGSRChange,
    riskFreePaintedDoor
  } = useToggles();

  const props = {
    analytics,
    registeredUser,
    queryGetUser,
    getFundingAccounts,
    answers,
    flowId,
    appOs,
    promoId: promotionId,
    nextRegStep,
    error,
    upgradePlanError,
    currentPlanName: currentPlan,
    message,
    upgradePlanErrorMessage,
    partner,
    needsVerification,
    creditWaitlistEnabled,
    registrationToken,
    completeUser,
    postRegComplete,
    subscribeSMS,
    planFlow,
    improvedDownloadScreen,
    enableCorePriceChange,
    enableGSRChange,
    riskFreePaintedDoorEnabled: riskFreePaintedDoor.enabled
  };

  return <DDRComplete {...props} />;
};

export default DDRCompleteContainer;
